import { SingleSelectField } from "@dgs/core";
import { useTranslation } from "react-i18next";
import { AttributeType } from "./analyticsTypes";

interface Props {
	name: string;
	label: string;
	onChange?: () => void;
	disabled?: boolean;
}

const options: AttributeType[] = [
	AttributeType.eventType,
	AttributeType.organizationalUnits,
	AttributeType.industries,
	AttributeType.organizer,
	AttributeType.format,
	AttributeType.category,
	AttributeType.targetGroup,
	AttributeType.region,
	AttributeType.tags,
];

export function EventTypeRequirementSelect({ name, label, onChange, disabled }: Props) {
	const { t } = useTranslation();

	return (
		<SingleSelectField
			name={name}
			label={label}
			options={options}
			getLabel={(o) => t(o)}
			onChange={onChange}
			disabled={disabled}
		/>
	);
}
